export const TV_GENRES_FETCH_SUCCESS = 'TV_GENRES_FETCH_SUCCESS';
export const TV_GENRES_FETCH_ERROR = 'TV_GENRES_FETCH_ERROR';

export const MOVIE_GENRES_FETCH_SUCCESS = 'MOVIE_GENRES_FETCH_SUCCESS';
export const MOVIE_GENRES_FETCH_ERROR = 'MOVIE_GENRES_FETCH_ERROR';

export const PERSON_FETCH_SUCCESS = 'PERSON_FETCH_SUCCESS';
export const PERSON_FETCH_ERROR = 'PERSON_FETCH_ERROR';

export const MOVIES_FETCH_SUCCESS = 'MOVIES_FETCH_SUCCESS';
export const MOVIES_FETCH_ERROR = 'MOVIES_FETCH_ERROR';

export const MOVIE_FETCH_SUCCESS = 'MOVIE_FETCH_SUCCESS';
export const MOVIE_FETCH_ERROR = 'MOVIE_FETCH_ERROR';

export const TVS_FETCH_SUCCESS = 'TVS_FETCH_SUCCESS';
export const TVS_FETCH_ERROR = 'TVS_FETCH_ERROR';

export const TV_FETCH_SUCCESS = 'TV_FETCH_SUCCESS';
export const TV_FETCH_ERROR = 'TV_FETCH_ERROR';

export const TV_SEASON_FETCH_SUCCESS = 'TV_SEASON_FETCH_SUCCESS';
export const TV_SEASON_FETCH_ERROR = 'TV_SEASON_FETCH_ERROR';

export const HOME_MOVIE_FETCH_SUCCESS = 'HOME_MOVIE_FETCH_SUCCESS';
export const HOME_TV_FETCH_SUCCESS = 'HOME_TV_FETCH_SUCCESS';

export const MULTI_SEARCH_FETCH_SUCCESS = 'MULTI_SEARCH_FETCH_SUCCESS';
export const MULTI_SEARCH_FETCH_ERROR = 'MULTI_SEARCH_FETCH_ERROR';

export const SINGLE_SEARCH_FETCH_SUCCESS = 'SINGLE_SEARCH_FETCH_SUCCESS';
export const SINGLE_SEARCH_FETCH_ERROR = 'SINGLE_SEARCH_FETCH_ERROR';

export const SEARCH_QUERY_EMPTY = 'SEARCH_QUERY_EMPTY';

export const USER_LOGIN_PENDING = 'USER_LOGIN_PENDING';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_ERROR = 'USER_LOGIN_ERROR';

export const USER_REGISTER_PENDING = 'USER_REGISTER_PENDING';
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export const USER_REGISTER_ERROR = 'USER_REGISTER_ERROR';

export const SAVE_USER_MEDIA_PENDING = 'SAVE_USER_MEDIA_PENDING';
export const SAVE_USER_MEDIA_SUCCESS = 'SAVE_USER_MEDIA_SUCCESS';
export const SAVE_USER_MEDIA_ERROR = 'SAVE_USER_MEDIA_ERROR';

export const FETCH_USER_MEDIA_SUCCESS = 'FETCH_USER_MEDIA_SUCCESS';
export const FETCH_USER_MEDIA_ERROR = 'FETCH_USER_MEDIA_ERROR';

export const REMOVE_USER_MEDIA_SUCCESS = 'REMOVE_USER_MEDIA_SUCCESS';
export const REMOVE_USER_MEDIA_ERROR = 'REMOVE_USER_MEDIA_ERROR';
